module.exports = __webpack_public_path__ + "img/bannerhomewl.509444e5.jpg";